import React from 'react';
import { Route } from '../../routing/routes';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { MacOSIcon, WindowsIcon } from '../Icons/PlatformIcons';
import './PlatformButton.scss';

const platformIcons = {
  windows: {
    component: <WindowsIcon />,
    text: 'Windows',
  },
  macos: {
    component: <MacOSIcon />,
    text: 'MacOS',
  },
};

export function PlatformButton(props: PlatformButtonProps) {
  const platformData = platformIcons[props.platform];

  return (
    <Link to={props.disabled ? '' : props.link} className="platform-button-link">
      <Button primary className="platform-button">
        {platformData.component}
        <span className="platform-button-text">
          {props.text} ({platformData.text})
        </span>
      </Button>
    </Link>
  );
}

export type PlatformButtonProps = {
  platform: Platform;
  text: string;
  link: Route;
  disabled?: boolean;
};

type Platform = keyof typeof platformIcons;
